
import React from 'react';
import { observer } from 'mobx-react';
import { ImgHome } from '../components/Images/ImgHome';

const imgArray = ['/img/cat_hungry.png', '/img/facepalm.apng', '/img/cat_cage.png'];

@observer
export default class Page404 extends React.Component {

  render(){
    const currentUrl = window.location.href;
    const img = imgArray[Math.floor(Math.random() * imgArray.length)];

    return (
      <div className="error-page">
        <div className="error-card">
          <img src={img} className="top-image" alt="" />
          <h1>Oops!</h1>
          <h2>404 Not Found</h2>
          <div className="error-details">
            Sorry, an error has occured, Requested page not found <br/>
            (You are trying to access page &quot;<b>{currentUrl}</b>&quot;)
          </div>
          <div className="error-actions">
            <a href="/" className="btn btn-primary">
              <ImgHome size={16} />
              &nbsp;Take Me Home
            </a>
          </div>
        </div>
      </div>
    );
  }
}